import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../Assets/Logo.png";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("nav-open");
    } else {
      document.body.classList.remove("nav-open");
    }

    const handleKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="WyRowing Logo" className="logo-img" />
        <span className="logo-text">
          Wyandotte Roosevelt High School Rowing
        </span>
      </div>

      <div className="hamburger-row">
        <button
          className="hamburger"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
        >
          ☰
        </button>
      </div>

      <nav className={`nav ${isOpen ? "open" : ""}`}>
        <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>
          Home
        </Link>

        <div className="nav-separator" />
        <div className="dropdown">
          <span className="dropdown-title">What's New?</span>
          <div className="dropdown-content">
            <Link to="/news" onClick={() => setIsOpen(false)}>News</Link>
            <Link to="/calendar" onClick={() => setIsOpen(false)}>Calendar</Link>
            <Link to="/gallery" onClick={() => setIsOpen(false)}>Media</Link>
          </div>
        </div>

        <div className="nav-separator" />
        <div className="dropdown">
          <span className="dropdown-title">What Do I Need?</span>
          <div className="dropdown-content">
            <Link to="/regattas" onClick={() => setIsOpen(false)}>Regattas</Link>
            <Link to="/student-forms" onClick={() => setIsOpen(false)}>Forms & FAQs</Link>
            <Link to="/shop" onClick={() => setIsOpen(false)}>Gear Up</Link>
          </div>
        </div>

        <div className="nav-separator" />
        <div className="dropdown">
          <span className="dropdown-title">How Can I Help?</span>
          <div className="dropdown-content">
            <Link to="/donate" onClick={() => setIsOpen(false)}>Donate</Link>
            <Link to="/sponsors" onClick={() => setIsOpen(false)}>Sponsors</Link>
            <Link to="/volunteers" onClick={() => setIsOpen(false)}>Volunteers</Link>
          </div>
        </div>

        <div className="nav-separator" />
        <div className="dropdown">
          <span className="dropdown-title">Who Are We?</span>
          <div className="dropdown-content">
            <Link to="/about" onClick={() => setIsOpen(false)}>About Us</Link>
            <Link to="/coaches" onClick={() => setIsOpen(false)}>Coaches</Link>
            <Link to="/board" onClick={() => setIsOpen(false)}>FRHSR Info</Link>
            <Link to="/archives" onClick={() => setIsOpen(false)}>Archives</Link>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
